import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Card} from 'components/ui';
import {LAYOUT_TYPE_MODERN} from 'constants/theme.constant';
import {useSelector} from 'react-redux';

const AdaptableCard = props => {
    const {
        className,
        children,
        bodyClass,
        leftSideBorder,
        rightSideBorder,
        divider,
        shadow,
        isLastChild,
        ...rest
    } = props;

    const type = useSelector(state => state.theme.layout.type);

    return (
        <Card
            className={classNames(
                className,
                type === LAYOUT_TYPE_MODERN && 'border-0',
                type === LAYOUT_TYPE_MODERN &&
                    rightSideBorder &&
                    'rounded-br-none rounded-tr-none md:border-gray-200 md:dark:border-gray-600 ltr:border-r-0 ltr:md:border-r rtl:rounded-br-none rtl:rounded-tr-none rtl:border-l-0 rtl:md:border-l',
                type === LAYOUT_TYPE_MODERN &&
                    leftSideBorder &&
                    'rounded-bl-none rounded-tl-none md:border-gray-200 md:dark:border-gray-600 ltr:border-l-0 ltr:md:border-l rtl:rounded-bl-none rtl:rounded-tl-none rtl:border-r-0 rtl:md:border-r',
                type === LAYOUT_TYPE_MODERN &&
                    divider &&
                    `${
                        !isLastChild ? 'border-b pb-6' : ''
                    } rounded-bl-none rounded-br-none py-4 md:border-gray-200 md:dark:border-gray-600`,
                type !== LAYOUT_TYPE_MODERN && shadow && 'rounded-none border-0 shadow-none',
            )}
            {...rest}
            bodyClass={classNames(type === LAYOUT_TYPE_MODERN ? 'card-gutterless' : '', bodyClass)}
        >
            {children}
        </Card>
    );
};

AdaptableCard.propTypes = {
    leftSideBorder: PropTypes.bool,
    rightSideBorder: PropTypes.bool,
    divider: PropTypes.bool,
    shadow: PropTypes.bool,
    isLastChild: PropTypes.bool,
};

export default AdaptableCard;
